var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_1199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 3.00005C22.5424 3.67552 21.4821 4.19216 20.36 4.53005C19.7577 3.83756 18.9573 3.34674 18.067 3.12397C17.1767 2.90121 16.2395 2.95724 15.3821 3.2845C14.5247 3.61176 13.7884 4.19445 13.273 4.95376C12.7575 5.71308 12.4877 6.61238 12.5 7.53005V8.53005C10.7426 8.57561 9.00127 8.18586 7.43101 7.39549C5.86074 6.60513 4.51032 5.43868 3.5 4.00005C3.5 4.00005 -0.5 13 8.5 17C6.44053 18.398 3.98716 19.099 1.5 19C10.5 24 21.5 19 21.5 7.50005C21.4991 7.2215 21.4723 6.94364 21.42 6.67005C22.4406 5.66354 23.1608 4.39276 23.5 3.00005Z",
    stroke: "#FEFDFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_1199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.311b96cce0cb6e2cb3ae40c4dbd8dd2e.svg";
export { ForwardRef as ReactComponent };